// importacao.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportacaoService {
  // BehaviorSubjects para os estados observáveis
  private _progressBarValue = new BehaviorSubject<number>(0);
  private _progressBarLen = new BehaviorSubject<number>(0);
  private _importandoItens = new BehaviorSubject<boolean>(false);
  private _incremento: number = 1;

  // Observables públicos para componentes se inscreverem
  public progressBarValue$: Observable<number> = this._progressBarValue.asObservable();
  public progressBarLen$: Observable<number> = this._progressBarLen.asObservable();
  public importandoItens$: Observable<boolean> = this._importandoItens.asObservable();

  constructor() {
    this.resetProgress();
  }

  // Getters para valores atuais
  public get progressBarValue(): number {
    return this._progressBarValue.getValue();
  }

  public get progressBarLen(): number {
    return this._progressBarLen.getValue();
  }

  public get importandoItens(): boolean {
    return this._importandoItens.getValue();
  }

  // Setters com notificação de mudança
  public set progressBarValue(value: number) {
    this._progressBarValue.next(value);
  }

  public set progressBarLen(value: number) {
    this._progressBarLen.next(value);
    this._incremento = Math.ceil(100 / value);
  }

  // Métodos para controlar o estado da importação
  public impOn(): void {
    this._importandoItens.next(true);
    console.log('Importação iniciada');
  }

  public impOff(): void {
    this._importandoItens.next(false);
    this.resetProgress();
    console.log('Importação finalizada');
  }

  public increment(): void {
    const novoValor = Math.min(this.progressBarValue + this._incremento, 100);
    this._progressBarValue.next(novoValor);
  }

  public resetProgress(): void {
    this._progressBarValue.next(0);
  }

  // Método para iniciar uma nova importação
  public iniciarImportacao(totalItens: number): void {
    this.progressBarLen = totalItens;
    this.resetProgress();
    this.impOn();
  }

  // Método para finalizar a importação
  public finalizarImportacao(): void {
    // Garantir que a barra chegue a 100% antes de finalizar
    this._progressBarValue.next(100);
    
    // Pequeno delay para mostrar 100% antes de resetar
    setTimeout(() => {
      this.impOff();
    }, 500);
  }

  // Método para verificar se está importando (útil para templates)
  public estaImportando(): boolean {
    return this.importandoItens;
  }
}